export function getIsNativeViewClient() {
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    return /quince_app_webview/i.test(userAgent)
  }

  return false
}
